import React from 'react';
import { useSelector } from 'react-redux';
import ModalHeader from 'components/Modal/Header';
import { HOST_PERMISSION_CHANGED } from '@studio/constants';

import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { CheckSystemButton as Button } from '@shoflo/polymer/dist/components/Join/JoinComponent.styled';

const HostPermissionRemoved = () => {
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === HOST_PERMISSION_CHANGED
  );

  const description =
    'Your host permissions were revoked so we removed you from the session. If this doesn’t sound right, contact the planner.';

  const footer = (
    <>
      <Button
        onClick={() => {
          window.close();
        }}
        color="outline"
        data-testid="close-host-permisssion-changed-modal"
      >
        Close
      </Button>
    </>
  );

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>You were removed from this session</ModalHeader>
      <ModalBody>{description}</ModalBody>
      <ModalFooter>{footer}</ModalFooter>
    </Modal>
  );
};

export default HostPermissionRemoved;
